import { blockTemplates } from "~/App/config/blockTemplates";

type Block = {
  template: string;
} & any;

type Page = {
  preview: {
    heading: string;
    preamble: string;
  };
};

interface Faq extends Block {
  pages: Page[];
  settings: {
    faqSchema: boolean;
  };
}

interface Data {
  template: string;
  blocks: Block[]
}

interface SchemaObj {
  "@type": "Question";
  name: string;
  acceptedAnswer: {
    "@type": "Answer";
    text: string;
  }
}



export function faqSchema(data: Data) {
  if (data.template !== "block") {
    return;
  }

  const faqBlocks: SchemaObj[] = data.blocks.reduce((prev, current) => {
    if (current.template === blockTemplates.faq) {
      const faq: Faq = current;

      if (faq.settings.faqSchema) {
        const answers = faq.pages.map((page) => {
          const { preview } = page;
          const stripLinks = preview.preamble.replace(
            /<a\b[^>]*>[\s\S]*?<\/a>/g,
            ''
          );
          const answer = stripLinks.replace(/<[\/?[b-zB-Z]*[\d]*>/g, '');

          return {
            '@type': 'Question',
            name: preview.heading,
            acceptedAnswer: {
              '@type': 'Answer',
              text: answer
            }
          };
        });

        return [...prev, ...answers];
      }
    }

    return prev;
  }, []);

  if (faqBlocks.length < 1) {
    return;
  }

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqBlocks
  };

  return jsonLd;
}